// extracted by mini-css-extract-plugin
export default {"FloatingMenu":"FloatingMenu_FloatingMenu__7ORpv"};